"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withDerivedProp = void 0;

var _withDerivedProps2 = _interopRequireDefault(require("./withDerivedProps"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var withDerivedProp = function withDerivedProp(source, handler) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      target = _ref.target;

  return (0, _withDerivedProps2["default"])([source], _defineProperty({}, target || source, function (props) {
    return handler(props[source]);
  }));
};

exports.withDerivedProp = withDerivedProp;